import React from 'react'
import {
  Briefcase,
  Calendar,
  Car,
  Cpu,
  GraduationCap,
  Home,
  Megaphone,
  Palette,
  Tag,
} from 'lucide-react'

type IconProps = {
  size?: number
  className?: string
}

export const CATEGORY_ICON_BY_SLUG: Record<string, React.ComponentType<IconProps>> = {
  'home-construction': Home,
  tech: Cpu,
  'business-services': Briefcase,
  creative: Palette,
  'marketing-sales': Megaphone,
  auto: Car,
  events: Calendar,
  education: GraduationCap,
}

export function CategoryIcon({
  slug,
  size = 16,
  className = 'text-white/70',
}: {
  slug: string
  size?: number
  className?: string
}) {
  const Icon = CATEGORY_ICON_BY_SLUG[String(slug || '').trim()] ?? Tag
  return <Icon size={size} className={className} aria-hidden="true" />
}
